<template>
  <customModal 
    :containermd="true" 
    @closeModal="handleClose"
  >
    <template #title>
      <span>{{ $t("navigations.upload consent form") }}</span>
    </template>

    <template #body>
      <div>
        <div class="row">
          <div class="col-12 col-md-6 pr-md-1 mt-2">
            <label for="document-title">Consent Form Title</label>
            <input
              id="document-title"
              type="text"
              class="form-control"
              maxlength="75"
              v-model.trim="docTitle"
              placeholder="Enter document title"
            />
          </div>

          <div class="col-12 col-md-6 mt-2">
            <label for="version">Version</label>
            <input
              id="version"
              type="text"
              class="form-control"
              maxlength="10"
              v-model.trim="docVersion"
              placeholder="Enter version"
            />
            <span class="d-block errorClass" v-if="documentValidationsError.version">
              Please enter a version
            </span>
          </div>

          <div class="col-12 col-md-6 mt-2">
            <label for="expiry-date">Effective Date</label>
            <input
              id="expiry-date"
              type="text"
              class="form-control"
              v-model="documentUploadFields.effectiveDate"
              onfocus="(this.type='date')"
              onblur="(this.type='text')"
              placeholder="Select a date"
              maxlength="30"
            />
            <!-- <span class="d-block errorClass" v-if="documentValidationsError.effectiveDate">
              Please enter a future date
            </span> -->
          </div>
<div class="col-12 col-md-6 mt-2">
  <label for="language">Language</label>

  <select
    id="language"
    class="form-control"
    v-model="language"
  >
    <option value="">Select Language</option>

    <option
      v-for="item in languageOptions"
      :key="item.code"
      :value="item.language"
    >
      {{ item.language }}
    </option>
  </select>
</div>

          <div class="col-12 col-md-6 mt-2">
            <label for="status">Status</label>
            <input
              id="status"
              type="text"
              class="form-control"
              v-model="status"
              disabled
            />
          </div>

          <div class="col-12 col-md-6 mt-2">
            <label for="expiry-date">Expiry Date</label>
            <input
              id="expiry-date"
              type="text"
              class="form-control"
              v-model="documentUploadFields.expiryDate"
              onfocus="(this.type='date')"
              onblur="(this.type='text')"
              placeholder="Select a date"
              maxlength="30"
            />
            <span class="d-block errorClass" v-if="documentValidationsError.expiryDate">
             Please enter a future date
            </span>
          </div>
              <div class="col-12 col-md-6 mt-2">
            <label for="language">IRB Approval Number</label>
            <input
              id="language"
              type="text"
              class="form-control"
              maxlength="50"
              v-model.trim="documentUploadFields.irbApprovalNumber"
              placeholder="Enter IRB Approval Number"
            />
          </div>
            <div class="col-12 col-md-6 mt-2">
            <label for="expiry-date">IRB Approval Date</label>
            <input
              id="expiry-date"
              type="text"
              class="form-control"
              v-model="documentUploadFields.irbApprovalDate"
              onfocus="(this.type='date')"
              onblur="(this.type='text')"
              placeholder="Select a date"
              maxlength="30"
            />
            <!-- <span class="d-block errorClass" v-if="documentValidationsError.irbApprovalDate">
              Please enter a future date
            </span> -->
          </div>
           
          

          <div class="col-12 mt-2">
            <label for="description">Description</label>
            <textarea
              id="description"
              class="form-control"
              maxlength="250"
              v-model.trim="documentUploadFields.description"
              placeholder="Enter description"
            ></textarea>
          </div>

          <div class="col-12 mt-2">
            <input
              ref="fileInput"
              id="upload-file-input"
              type="file"
              class="form-control d-none my-2 my-md-0"
              accept=".xls,.xlsx,.jpg,.jpeg,.png,.pdf,.docx,.doc"
              @change="previewFiles"
              multiple
            />
            <div
              v-for="(f, idx) in list"
              :key="`${f.name}-${idx}`"
              class="input-group"
            >
              <div class="listfile breakWord">
                <a>
                  {{ f.name }}
                  <i class="fa fa-close" @click.prevent="removefile(idx)"></i>
                </a>
              </div>
            </div>
            <span class="errorClass" v-if="documentValidationsError.file">
              Please upload a file
            </span>
          </div>
        </div>

        <div class="d-flex justify-content-end mt-2">
          <button
            class="browser-btn py-1 px-3 mr-2"
            type="button"
            @click="browse"
          >
            <p class="mb-0">{{ $t("navigations.browse") }}</p>
          </button>

          <button
            type="button"
            class="save_btn py-1 px-3 position-relative"
            :disabled="loadingDocUpload"
            :class="{ 'disabled-btn-cls': loadingDocUpload }"
            @click="submitFile"
          >
            <div
              class="toc-loader position-absolute"
              :class="{
                'opacity-0': !loadingDocUpload,
                'opacity-1': loadingDocUpload,
              }"
            >
              <img
                src="../../assets/img/loading.gif"
                width="15"
                class="loading-btn-img"
                alt="Waiting for login"
              />
            </div>
            <p
              class="mb-0"
              :class="{
                'opacity-1': !loadingDocUpload,
                'opacity-0': loadingDocUpload,
              }"
            >
              {{ $t("navigations.save") }}
            </p>
          </button>
        </div>
      </div>
    </template>
  </customModal>
</template>

<script src="./consentdocumentupload.js"></script>

<style scoped>
.browser-btn {
  border: 1px solid #e7eaec;
  background-color: #e7eaec;
  border-radius: 0.25rem;
}
.errorClass {
  color: #d9534f;
  font-size: 0.85rem;
}
.opacity-0 {
  opacity: 0;
}
.opacity-1 {
  opacity: 1;
}
.disabled-btn-cls {
  opacity: 0.6;
  cursor: not-allowed;
}
.listfile {
  padding: 8px 12px;
  background-color: #f8f9fa;
  border-radius: 4px;
  margin-bottom: 5px;
}
.listfile a {
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.breakWord {
  word-break: break-all;
}
</style>